module.exports = __webpack_public_path__ + "static/fix-products-bought-together-api-changed-48460e51512af193796c4773510f6000.png";